export default __webpack_public_path__ + "static/media/cloudFront.1de72a8e.svg";